"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require("react-bootstrap");

var _styled = require("./styled.gallery");

var _baseHelper = require("../../helper/baseHelper");

var _baseHelper2 = _interopRequireDefault(_baseHelper);

var _defaultProps = require("./defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPropValue = _baseHelper2.default.getPropValue;


var GalleryHeader = function GalleryHeader(props) {
  var handleSortValueChange = props.handleSortValueChange,
      handleSearchChange = props.handleSearchChange,
      searchValue = props.searchValue,
      _props$productCount = props.productCount,
      productCount = _props$productCount === undefined ? 0 : _props$productCount;


  var newProps = _extends({}, _defaultProps2.default.props);

  var style = newProps.style;


  return _react2.default.createElement(
    _reactBootstrap.Container,
    { className: "px-lg-4" },
    _react2.default.createElement(
      "h5",
      { className: "text-uppercase text-left mb-4" },
      "Products (" + productCount + ")"
    ),
    _react2.default.createElement(
      _styled.FilterToolbar
      // {...filterToolbarProps}
      ,
      { className: "filter-toolbar row align-items-center mb-4"
      },
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 3, xs: 8 },
        _react2.default.createElement(
          _styled.SearchBar
          // {...searchProps}
          ,
          { className: "form-group has-search w-100 mb-0 position-relative"
          },
          _react2.default.createElement("i", {
            className: "fa fa-search search-icon position-absolute",
            "aria-hidden": "true"
          }),
          _react2.default.createElement(_styled.StyledInput
          // {...inputStyleProps}
          , { type: "text",
            className: "form-control",
            value: searchValue,
            onChange: handleSearchChange,
            placeholder: "Search"
          })
        )
      ),
      _react2.default.createElement(
        _reactBootstrap.Col,
        { md: 4, xs: 4, className: "offset-md-5" },
        _react2.default.createElement(
          _styled.StyledListGroup,
          { horizontal: true, className: "social gallery-icons p-0" },
          _react2.default.createElement(
            _reactBootstrap.ListGroup.Item,
            { className: "sort-drop p-0 ml-auto border-0" },
            _react2.default.createElement(
              _reactBootstrap.DropdownButton,
              {
                alignRight: true,
                title: "Sort By",
                id: "dropdown-menu-align-right",
                className: "dropdown-margin"
              },
              _react2.default.createElement(
                _reactBootstrap.Dropdown.Item,
                {
                  eventKey: "1",
                  onSelect: function onSelect() {
                    return handleSortValueChange("createdAt", "asc");
                  }
                },
                "Date (Asc)"
              ),
              _react2.default.createElement(
                _reactBootstrap.Dropdown.Item,
                {
                  eventKey: "2",
                  onSelect: function onSelect() {
                    return handleSortValueChange("createdAt", "desc");
                  }
                },
                "Date (Desc)"
              ),
              _react2.default.createElement(
                _reactBootstrap.Dropdown.Item,
                {
                  eventKey: "3",
                  onSelect: function onSelect() {
                    return handleSortValueChange("title", "asc");
                  }
                },
                "Product Title (Asc)"
              ),
              _react2.default.createElement(
                _reactBootstrap.Dropdown.Item,
                {
                  eventKey: "4",
                  onSelect: function onSelect() {
                    return handleSortValueChange("title", "desc");
                  }
                },
                "Product Title (Desc)"
              )
            )
          )
        )
      )
    )
  );
};
exports.default = GalleryHeader;